var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{class:[
    _vm.$options.name,
    ( _obj = {}, _obj[("" + _vm.styleClass)] = _vm.styleClass, _obj )],domProps:{"innerHTML":_vm._s(_vm.leadText)}})}
var staticRenderFns = []

export { render, staticRenderFns }